<template>
  <!-- 基础数据-职位、部门角色公用 -->
  <div class="page-staff-person">
    <div class="wrap">
      <!-- <p>基础数据-职位、部门角色公用{{pageType}}</p> -->
      <div class="button">
        <el-button class="el-primary-border" @click="add('', '')">
          <svg-icon icon-class="add"/>
          &nbsp;{{pageType==='job'?'新增职位':'新增部门角色'}}
        </el-button>
      </div>

      <!-- 表格 -->
      <div class="table mt-20">
        <el-table stripe :data="tableData" v-loading="listLoading">
          <el-table-column prop="name" label="职位名称" min-width="40%"></el-table-column>
          <el-table-column prop="date" label="创建日期" min-width="40%"></el-table-column>

          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="edit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="dele(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    $route(path) {
      this.pageType = path.query.pageType
      this.initList()
    }
  },
  data() {
    return {
      pageType: this.$route.query.pageType, // job:职位  department:部门角色
      tableData: [],
      listLoading: true
    }
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.$http
        .get('/job/list', {
          ...this.listQuery,
          type: this.pageType === 'job' ? 'job' : 'dept'
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 新增职位
    add(item) {
      this.$prompt('', this.pageType === 'job' ? '职位名称' : '部门角色', {
        showClose: true,
        // showCancelButton: false,
        confirmButtonText: '确定',
        inputPlaceholder: '请输入',
        inputValue: (item && item.name) || null,
        // inputPattern: /^[\S]{1,10}$/,
        inputPattern: /^.{1,10}$/,
        inputErrorMessage: '请输入1到10位字符'
        // center: true
      })
        .then(({ value }) => {
          if (!item) {
            this.addRemote(item, value)
          } else {
            this.editRemote(item, value)
          }
        })
        .catch(() => {})
    },
    edit(item) {
      this.add(item)
    },
    dele(id) {
      this.$common.confirm(
        {
          title:
            this.pageType === 'job'
              ? '您正在删除职位，是否确认删除？'
              : '您正在删除部门角色，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          console.log('删除')
          this.$http
            .post('/job/delete', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success(
                  this.pageType === 'job' ? '删除职位成功' : '删除部门成功'
                )
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    addRemote(item, value) {
      this.$http
        .post('/job/add', {
          type: this.pageType === 'job' ? 'job' : 'dept',
          name: value
        })
        .then(res => {
          if (res.success) {
            this.$message.success(
              this.pageType === 'job' ? '新增职位成功' : '新增部门成功'
            )
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    editRemote(item, value) {
      this.$http
        .post('/job/update', {
          id: item.id,
          name: value
        })
        .then(res => {
          if (res.success) {
            this.$message.success(
              this.pageType === 'job' ? '编辑职位成功' : '编辑部门成功'
            )
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.page-staff-person {
  .wrap {
    padding: 30px;
    background: #fff;
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
    border-radius: 4px;
  }
}
</style>


